<div class="routeFilter" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}" *ngIf="_isVisiblePanel" id="panelRoutes">
  <loading [isLoading]="isLoading"></loading>
  
  <div class="header-panel">
    <div class="btnClose">
      <img [src]="'cancelar.svg' | findUrl" (click)="onClose()">
    </div>

    <h3 >Control de Rutas</h3>

    <div *ngIf="!mobileQuery.matches && !fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_up</mat-icon>
    </div>
    <div *ngIf="!mobileQuery.matches && fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_down</mat-icon>
    </div>

  </div>

  <!-- <div class="search-Arrow-flex">
    <div style="flex-basis: 70%; text-align: center;">
      <h3 *ngIf="!fullScreen" style="margin: 0; color: var(--primary-color-dark); font-size: 15px; font-weight: bold;">Control de Rutas</h3>
    </div>
    
  </div> -->

    <form #forma="ngForm" class="route-form">
      <div class="input-group">
        <label class="input-label">Identificador o Contrato</label>
        <mat-form-field appearance="outline" class="custom-input" color="accent">
          <input type="text" 
            [(ngModel)]="request.identifier"
            [placeholder]="placeholder"
            name="identifier"
            minlength="5"
            required
            aria-label="Number"
            (focus)="focusLocation()"
            matInput [formControl]="myControl" [matAutocomplete]="auto" >
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected()">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <span *ngIf="showIdentifierError" style="color: red; font-size: 12px;">No se ha seleccionado ningún valor</span>
      </div>

      <div class="raw-checkbox">
        <label class="switch">
          <mat-slide-toggle (change)="setRawRequest()"></mat-slide-toggle>
          <!-- <img *ngIf="isRawRequest" [src]="'btn_on.svg' | findUrl" class="img-button" (click)="setRawRequest()">
          <img *ngIf="!isRawRequest" [src]="'btn_off.svg' | findUrl" class="img-button" (click)="setRawRequest()"> -->
        </label>
        <span matTooltip="* Se mostrarán como máximo 3 horas posteriores a la hora seleccionada.">Modo Avanzado</span>
      </div>
      
      <div class="date-selector" *ngIf="!isRawRequest">
        <div class="input-group">
          <label class="input-label">Introduce un rango de fechas</label>
          <mat-form-field class="custom-input" appearance="outline" color="accent">
            <mat-date-range-input [rangePicker]="picker" [max]="maxStartDate" [disabled]="isDatePickerDisabled">
              <input [(ngModel)]="request.startDate" matStartDate placeholder="Desde" name="startDate" (dateInput)="limteFecha($event)" (click)="picker.open()">
              <input [(ngModel)]="request.endDate" matEndDate placeholder="Hasta" name="endDate" (click)="picker.open()">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"  [disabled]="isDatePickerDisabled">
              <mat-icon matDatepickerToggleIcon svgIcon="custom_calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
      
      <div class="date-selector" *ngIf="isRawRequest">
        <div class="input-group">
          <label class="input-label">Fecha</label>
          <mat-form-field class="custom-input" appearance="outline" color="accent">
            <input matInput [matDatepicker]="picker" [(ngModel)]="rawDate" name="rawDate" (dateChange)="onDateChange($event)" (click)="picker.open()" [disabled]="isDatePickerDisabled">
            <mat-datepicker-toggle matIconSuffix [for]="picker" ></mat-datepicker-toggle>
            <mat-datepicker #picker ></mat-datepicker>
          </mat-form-field>
        </div>
        
        <div class="input-group">
          <label class="input-label">Hora de inicio</label>
          <mat-form-field appearance="outline" class="custom-input">
            <input
              matInput
              placeholder="00:00"
              [(ngModel)]="rawStartTime"
              name="startTime"
              aria-label="24hr format"
              [ngxTimepicker]="startTime"
              [format]="24"
              [disabled]="isDatePickerDisabled"
              readonly>
            <ngx-material-timepicker
              #startTime
              [hoursOnly]="false">
            </ngx-material-timepicker>
          </mat-form-field>
        </div>

      </div>
      
      
      <!-- <mat-slide-toggle
        class="item_routeFilter"
        [checked]="checkedDia"
        (change)="ngOnSelectTime()"
      >
        Todo el dia </mat-slide-toggle
      ><br /> -->
     
      <!-- <input type="checkbox" value="Seleccionar Horas" (change)="ngOnSelectTime()"> -->
      <div class="divFechas" *ngIf="isSelectTime">
        <label class="item_routeFilter">Hora Inicio</label><br />
        <div class="24hr-example">
          <input
            placeholder="Seleccionar"
            [(ngModel)]="request.startDate"
            name="startTime"
            aria-label="24hr format"
            [ngxTimepicker]="startTime"
            [format]="24"
            readonly
          />
          <ngx-material-timepicker
            #startTime
            [hoursOnly]="true"
          ></ngx-material-timepicker>
        </div>

        <label class="item_routeFilter">Hora Final</label><br />
        <div class="24hr-example">
          <input
            placeholder="Seleccionar"
            name="endTime"
            [(ngModel)]="request.endDate"
            aria-label="12hr format"
            [ngxTimepicker]="endTime"
            [format]="24"
            readonly
          />
          <ngx-material-timepicker
            #endTime
            [hoursOnly]="true"
          ></ngx-material-timepicker>
        </div>
       
      </div>

     

      <div class="row">
        <button mat-fab extended class="btnBuscar form-control" (click)="onSubmit()" [disabled]="isDatePickerDisabled">
          Buscar <mat-icon>search</mat-icon>
        </button>
      </div>
    </form>
</div>